import { onceEach } from "~/jose_modern/once.js";

export const bindCommentFormShortcuts = (container, formSelector = ".comment_form") => {
  onceEach(container.querySelectorAll(formSelector), "comments-form", (form) => {
    const textarea = form.querySelector("textarea");
    if (!textarea) return;

    textarea.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        form.requestSubmit();
      }
      if (e.key === "Escape") {
        const cancel = form.querySelector('[data-action="cancel"]');
        if (cancel) {
          e.preventDefault();
          cancel.click();
        }
      }
    });
  });
};
